import React from 'react'
import LogisticsServices from '../components/LogisticsServices'
/*Images-Icons*/
import Hero from '../assets/imagenes/Homepage2.png'
import BoatIcon from '../assets/imagenes/barco-de-carga 2.svg'
import DocumentIcon from '../assets/iconos/documentos.svg'
import GlobalIcon from '../assets/iconos/global 2.svg'
import Vector from '../assets/vectores/Vector 32blue vector.png'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { Link } from 'react-router-dom'
import '../styles/LandingPage.css'

import { useTranslation } from 'react-i18next';

function LandingPage() {
const {t} = useTranslation();

  return (
    <section className='LandingPage'>
    <section className="hero" style={{backgroundImage: `url(${Hero})`}}>
        <div className="content">
            <h1 className="text1">{t("lp_1")}</h1>
            <img src={Vector} alt="Vector" className='vector'/>
            <p className="text2">{t("lp_2")}</p>
            <Link to="/productos" className='productos-container'>
                <button className="productos">{t("lp_3")} <ArrowForwardOutlinedIcon style={{ fontSize: 20 }} /> </button>
            </Link> 
        </div>
    </section>
    <div className="contentMobile">
        <h1 className="text1">{t("lp_1")}</h1>
        <p className="text2">{t("lp_2")}</p>
        <Link to="/productos" className='productos-container'>
            <button className="productos">{t("lp_3")}</button>
        </Link> 
    </div>

    <section className='landingPageSection'>
        <div className='landingPage'>
            <div className='box1'>
                <img src={GlobalIcon} alt="Cargo Ship" className='icon' />
                <p className='subtitle'>{t("lps_1")}</p>
            </div>
            
            <div className='box2'>
                <img src={BoatIcon} alt="Documents" className='icon' />
                <p className='subtitle'>{t("lps_2")}</p>
            </div>
            
            <div className='box3'>
                <img src={DocumentIcon} alt="Global Shipping" className='icon' />
                <p className='subtitle'>{t("lps_3")}</p>
            </div>
        </div>
    </section>
    
    <LogisticsServices />
    <section style={{display: 'flex', justifyContent: 'center', margin: '20px'}}>
        <div className='degraded-container'>
        <div className='explora'>
            <div>
                <h3 style={{fontFamily: 'Outfit, sans-serif', color: '#421831', fontWeight: '700'}}>{t("lp_4")}</h3>
                <p>
                {t("lp_5")}
                </p>
            </div>
            <div>
                <h4>{t("lp_6")}</h4>
                <p>
                {t("lp_7")}
                </p>
                <h4>{t("lp_8")}</h4>
                <p>
                {t("lp_9")}
                </p>
            </div>
        </div>
        <div className='servicios-div' style={{width: '100%', display: 'flex', margin: '0px 40px'}}>
            <Link to="/servicios" className='NuestrosServicios-container'>
                <button className="NuestrosServicios">{t("lp_10")}</button>
            </Link>
        </div>
        </div>
    </section>
    </section>
  )
}

export default LandingPage